export const SITE = {
  brand: "Artı Bir Yapı",
  domain: "artibirinsaat.com",
  phoneDisplay: "0545 820 34 55",
  phoneTel: "+905458203455",
  whatsapp: "https://wa.me/905458203455?text=" + encodeURIComponent("Merhaba, evim için tadilat/yenileme hakkında hızlı fiyat bilgisi almak istiyorum."),
  address: "Şerifali Mahallesi, İbrahim Hakkı Sokak No: 21/1, Ümraniye / İstanbul",
  mapsQuery: "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Şerifali Mahallesi İbrahim Hakkı Sokak No 21/1 Ümraniye İstanbul"),
};
